import React from "react";
import {useNavigate} from 'react-router-dom';
import '../styles/UnauthorizedPage.css'
import {RUTAS} from "constants/app";
import {useTheme} from "../providers/ThemeProvider";


const UnauthorizedPage = () => {
    const { theme } = useTheme();
    const navigate = useNavigate();

    return (
        <div className="unauthorized-container">
            <div className="unauthorized-header">
                <img src={theme?.assets.iconNoAccess} alt="No autorizado" className="unauthorized-icon"/>
                <h1 className="unauthorized-title">{theme?.content.unauthorizedPage.title}</h1>
            </div>

            <div className="unauthorized-description">
                {theme?.content.unauthorizedPage.message}
            </div>

            <button className="unauthorized-button" onClick={() => navigate(RUTAS.ACCESO)}>
                {theme?.content.unauthorizedPage.returnButton}
            </button>

        </div>
    );
};

export default UnauthorizedPage;